const getters = {
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  userId: state => state.user.userId,
  userInfo: state => state.user.userInfo,
  mySetting: state => state.user.mySetting,
  windowData: state => state.config.windowData,
  isSave: state => state.config.isSave,
  showDetailNotice: state => state.config.showDetailNotice,
  showDateTips: state => state.config.showDateTips,
  allBtnReturnRouter: state => state.config.allBtnReturnRouter,
  fullBoxScreen: state => state.config.fullBoxScreen,
  showUploadTips: state => state.config.showUploadTips,
  currentProject: state => state.project.currentProject,
}
export default getters
